<form id="auth-form" [formGroup]="formGroup">
    <div class="auth-title">{{ 'AUTH.TWOFACTORSETUP.TITLE' | translate | uppercase }}</div>
    <div class="auth-sub-title" [innerHTML]="'AUTH.TWOFACTORSETUP.NOTICE' | translate"></div>
    <br>
    <div class="twofactor-setup-body">
        <div [formGroup]="formGroup"
             *ngIf="formGroup">
            <div class="image-container">
                <img
                class="two-factor-setup-qrcode"
                [src]="mfaQrCodeImage"
                alt="QR Code"
                />
            </div>
            <div class="verify-code-field">
                <aa-input-text2 [name]="CodeField"
                                    required
                                    label="{{ 'AUTH.TWOFACTORSETUP.VERIFYCODE' | translate }}"
                                    [formControlName]="CodeField">
                </aa-input-text2>
            </div>
            <div class="twofactor-setup-buttons">
        <aa-btn-action-secondary [btnText]="'BUTTON.SUBMIT' | translate" [cta]="onSubmit" [btnWidth]="'100%'">
        </aa-btn-action-secondary>
    </div>
        </div>
    </div>
    
</form>
